import React from 'react';

const ThirdPartyTemplate = () => {
  return (
    <section className="sub_container pt-0">
      <ul className="hd_info">
        <li>
          <span>공고일</span>
          2024.08.20
        </li>
        <li>
          <span>개정사항</span>
          약관내용수정
        </li>
        <li>
          <span>시행일</span>
          2024.08.20
        </li>
      </ul>
      <div className="Padding-20 text">
        회사는 서비스내에 회원이 요청한 처방전 불러오기 서비스를 제공하기 위해 건강보험심사평가원의 내가먹는약 정보연동을 위해 아래와 같은 제3자 정보제공동의를
        받고자 합니다.
        <br />
        <br />
        회원이 개인정보는 간편인증 서비스 이용 시 제 3자 제공 동의를 선택한 경우 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한 법률」에 따라 인증 소개
        및 안내 등을 위하여 귀하의 개인(신용)정보를 다음과 같이 제3자에게 제공하고자 합니다.
        <br />
        <br />
        <strong>1.개인정보의 제공</strong>
        <br />
        - 개인정보를 제공받는 자<br />
        ㆍ”건강보험심사평가원“
        <br />
        ㆍ”건강보험심사평가원“과 계약을 체결한 자<br />
        <br />
        <strong>2.제공받는자의 개인정보 수집 이용</strong>
        <br />
        1) 제공받는자의 개인정보 수집 이용 목적
        <br />
        간편인증 서비스(본인확인 인증) 제공
        <br />
        2) 제공할 개인정보의 항목
        <br />
        개인식별정보(성명, 생년월일, 성별, 외국인 여부, 연락처), 동의일자, 본인인증결과값(CI), 이동통신사, 고유식별번호(주민등록번호)
        <br />
        3) 개인정보 제공 기관
        <br />
        ① 전자서명인증기관 : 카카오, 통신사PASS, KB국민은행, payco, 삼성PASS, 네이버, 신한은행, 토스, 뱅크샐러드, NH농협, 하나은행, 드림인증
        <br />
        ② 신용정보사 : 나이스
        <br />
        - 고유식별번호로 인증시 제공
        <br />
        <br />
        <strong>3.제공받는자의 개인정보 보유 이용기간</strong>
        <br />
        간편인증 서비스(본인확인 인증) 후 즉시 파기
        <br />
        <br />
        <strong>4.개인정보의 제3자 제공 동의</strong>
        <br />
        회원은 개인(신용)정보의 선택적인 제공에 대한 동의를 거부할 수 있습니다. 다만, 동의하지 않으실 경우 간편인증(본인확인 인증) 서비스를 이용할 수 없습니다.
        <br />
      </div>
    </section>
  );
};

export default ThirdPartyTemplate;
